import { ResourceCentre } from "../interfaces/ResourceCentreInterface";
import { useAppSelector } from "../store/hooks";

const useKitchenPharmacy = (): ResourceCentre =>
  useAppSelector((state) => state.userContext?.user?.kitchenPharmacy);
export default useKitchenPharmacy;
